import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'octo-maintenance-mode',
    templateUrl: './maintenance-mode.component.html',
    styleUrls: ['./maintenance-mode.component.scss'],
})
export class MaintenanceModeComponent implements OnInit {
    maintenanceEndDate = 'Tuesday, January 21st';

    constructor() {}

    ngOnInit(): void {}
}
